import { defineComponent as _defineComponent } from 'vue';
import { useGetAccountQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'search',
  setup: function setup(__props) {
    var _useGetAccountQuery = useGetAccountQuery(),
      result = _useGetAccountQuery.result;
    var account = computed(function () {
      var _result$value;
      return ((_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getAccount) || {};
    });
    // Default sections
    var defaultSections = [117,
    // 'IRIS Indicators',
    82,
    // 'SFDR: PAI Indicators',
    967,
    // 'ImpactNexus Indicators',
    989,
    // 'EU taxonomy',
    998,
    // 'EDCI Metrics',
    1101 // 'KfW'
    ];
    var queryParams = computed(function () {
      return {
        sections: defaultSections,
        text: ''
      };
    });
    var selectedMetrics = ref([]);
    var customMetricFormDialog = ref(false);
    function addMetricAssignmentsFromTemplate(items) {
      customMetricFormDialog.value = true;
      selectedMetrics.value = items;
    }
    return {
      __sfc: true,
      result: result,
      account: account,
      defaultSections: defaultSections,
      queryParams: queryParams,
      selectedMetrics: selectedMetrics,
      customMetricFormDialog: customMetricFormDialog,
      addMetricAssignmentsFromTemplate: addMetricAssignmentsFromTemplate
    };
  }
});